import { forwardRef, useState, useCallback } from "react";
import { InPlaceMultiSelectEditor } from "@etframework/ui.components";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { useTags } from "../../data/queries/tagQueries";
import { useTranslation } from "react-i18next";

export const TagsMultiSelectInPlaceEditor = forwardRef(
  ({ id, value: initValues, actionSuccess, disabled }, ref) => {
    const [values, setValues] = useState(initValues);
    const { data: tags, isPending: isTagsPending } = useTags();
    const { t } = useTranslation(["Overlay"]);
    const fields = { text: "Title", value: "Id" };

    const onChange = useCallback(
      (e) => {
        e.value = ref.current?.getValue();
        if (JSON.stringify(values) !== JSON.stringify(e.value)) {
          setValues(e.value);
          actionSuccess?.(e);
        }
      },
      [actionSuccess]
    );

    return (
      <div>
        {isTagsPending ? (
          <SkeletonComponent
            height={"1.5em"}
            className="my-1"
            width={"300px"}
            shimmerEffect="Fade"
          />
        ) : (
          <InPlaceMultiSelectEditor
            dataSource={tags ?? []}
            fields={fields}
            id={id}
            ref={ref}
            name="Tags"
            type="MultiSelect"
            actionSuccess={onChange}
            value={isTagsPending ? null : values}
            placeholder={t("TagsPlaceholder")}
            emptyText={t("TagsPlaceholder")}
            allowObjectBinding
            allowCustomValue
            disabled={disabled}
          />
        )}
      </div>
    );
  }
);
